import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import vshare from 'vshare'

import API from './Api/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.css'
import './style/index.less'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible'
import { render } from 'less'

Vue.use(VueAwesomeSwiper)
Vue.use(vshare)

Vue.prototype.API = API // api接口请求
Vue.prototype.$Bus = new Vue // api接口请求

Vue.use(Vant)
Vue.use(ElementUI)
Vue.config.productionTip = false
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')